import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { DynamicDocCopy, DynaStatus } from '@/types';

import { Observable } from 'rxjs';

interface getDacEditDynamicDocsCopyDataTableStructureProps {
  rowActionsFn?: (target: DynamicDocCopy) => DataTableRowActions;
  createAction?: () => void;
  createActionDisabled?: Observable<boolean>;
}

export const getDacEditDynamicDocsCopyDataTableStructure = ({
  rowActionsFn,
  createAction,
  createActionDisabled,
}: getDacEditDynamicDocsCopyDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.dacDynamicDocCopy.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.dacDynamicDocCopy.table.name',
    accessorKey: 'name',
    variant: DataTableColumnVariant.TEXT,
  };

  const orderColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.dacDynamicDocCopy.table.order',
    accessorKey: 'ordre',
    variant: DataTableColumnVariant.TEXT,
  };

  const isAAOColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'dac.dacDynamicDocCopy.table.isAAO',
    accessorKey: 'isAAO',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value ? 'common.responses.yes' : 'common.responses.no' };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'info' : 'secondary';
      },
    },
  };

  const isStaticColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'dac.dacDynamicDocCopy.table.isStatic',
    accessorKey: 'isStatic',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value ? 'common.responses.yes' : 'common.responses.no' };
    },
    props: {
      getSeverity: (value: boolean) => {
        return value ? 'info' : 'secondary';
      },
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'dac.dacDynamicDocCopy.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: DynaStatus) => {
      return { value: value == DynaStatus.ACTIF ? 'common.responses.active' : 'common.responses.inactive' };
    },
    props: {
      getSeverity: value => {
        return value == DynaStatus.ACTIF ? 'success' : 'danger';
      },
    },
  };

  return {
    singular: 'dac.dacDynamicDocCopy.singular',
    plural: 'dac.dacDynamicDocCopy.plural',
    columns: [idColumn, nameColumn, orderColumn, isAAOColumn, isStaticColumn, statusColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    createActionDisabled,
    rowActionsFn,
  };
};
